import { connect } from 'react-redux';
import AgentCommissionSection from 'app/pages/AgentPricing/components/AgentCommissionSection';
import CompanyRatesSection from 'app/pages/AgentPricing/components/CompanyRatesSection';
import { AgentPricingTab } from 'app/pages/AgentPricing/actionTypes';
import { getSelectedTab } from 'app/pages/AgentPricing/modules/TabMenuBar';
import PublishedVersionsSection from 'app/pages/AgentPricing/components/PublishedVersionsSection';

interface StateProps {
    selectedTab: AgentPricingTab;    
}

function noSection() {
    return <div className="ui icon message error">
            <i className="exclamation triangle icon"></i>
            <div className="content">
                <div className="header">Missing section</div>
                <p>No section has been connected to the selected tab.</p>
            </div>            
        </div>;
}

const BookingSectionPanel = (props:StateProps) => {
    switch(props.selectedTab) {
        case AgentPricingTab.GroupRates:
            return <AgentCommissionSection />;
        case AgentPricingTab.CompanyRates:
            return <CompanyRatesSection />;
        case AgentPricingTab.VersionHistory:
            return <PublishedVersionsSection />;
        default:
            return noSection(); 
    }
}

const mapStateToProps = (state:any, ownProps:{}) => {
    const selectedTab = getSelectedTab(state);
    return {
        selectedTab: selectedTab
    }    
};

export default connect(mapStateToProps)(BookingSectionPanel);
